// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"styles_videoWrapper__HI1G4","videoOverlay":"styles_videoOverlay__zCNhj","playButton":"styles_playButton__9kMGU"};